module.exports = __webpack_public_path__ + "img/en-ng.d2651e9b.svg";